import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function GuideTerms() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            著作権について
          </Typography>
          　デーリー東北(本紙、ホームページ)に掲載された記事、写真、動画、イラストなどの著作権は、デーリー東北新聞社および配信した通信社など各情報提供者にあります。無断転載、再配信等は固くお断りします。<br/>
          　著作権については、日本新聞協会の見解に準拠します。<br/>

          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/daily-right" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            当サイトについて
          </Typography>
          <dl>
            <dt>おことわり</dt>
            <dd>
              　デーリー東北新聞社が当ウェブサイト上で提供する記事、写真、図表などの無断転載を禁止します。<br/>
              　著作権はデーリー東北新聞社またはその情報提供者に帰属します。全国、海外のニュースは共同通信社の配信を受けています。<br/>
              　ネットワーク上の著作権については<a href="https://www.pressnet.or.jp/statement/copyright/" target="_blank">日本新聞協会の見解</a>もご参照ください。<br/>
            </dd>
            <dt>推奨環境</dt>
            <dd>
              　当ウェブサイトの推奨環境は下記の通りです。
              <Box p={2}>
                <div class="font-weight-bold">
                  <ArrowRightIcon />ＰＣの場合
                </div>
                ▽ＯＳ<br/>
                Windows 8、Windows 10、Mac OS X 10.4以降<br/>
                ▽ブラウザ<br/>
                Firefox　最新版、Safari　最新版、Google Chrome 最新版、Microsoft Edge 最新版<br/>
              </Box>

              <Box p={2}>
                <div class="font-weight-bold">
                  <ArrowRightIcon />スマートフォンの場合
                </div>
                ▽ＯＳ<br/>
                iOS8以降、Android4.1以降<br/>
                ▽ブラウザ<br/>
                各OSで標準搭載しているブラウザ、Google Chrome<br/>
              </Box>

              <div className="fs90 line150 text-danger">
                ※推奨環境は、OSとブラウザ両方の条件を含んだ環境となります。<br/>
                ※上記環境以外では正常に表示されない場合があります。<br/>
                ※ブラウザのJavaScriptは必ずONにして閲覧してください。<br/>
                電子号外などのPDFファイルは【Adobe Reader】で見ることができます。<a href="https://get.adobe.com/reader/?loc=jp" target="_blank">入手はこちらから</a><br/>
                動画など一部コンテンツで【Adobe Flash】が使用されています。<a href="https://get.adobe.com/flashplayer/?loc=jp" target="_blank">入手はこちらから</a><br/>
              </div>
            </dd>
          </dl>
        </Box>

      </div>
    </div>
  );
}

export default GuideTerms;
